export default __webpack_public_path__ + "static/media/icon-flat.580bc2df.svg";